import React from "react";
import { Box, IconButton, Modal, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

const CustomModal = ({ open, handleClose, title, children }) => {
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex: 999999,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            border: "1px solid rgba(0,0,0,0.1)",
            padding: (theme) => theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            marginBottom: (theme) => theme.spacing(4),
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 1280,
            maxHeight: "90vh",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: (theme) => theme.spacing(2),
              paddingBottom: (theme) => theme.spacing(2),
              paddingLeft: (theme) => theme.spacing(4),
              paddingRight: (theme) => theme.spacing(4),
              borderBottom: "1px solid #EFEFEF",
              fontWeight: 600,
              position: "fixed",
              background: "#fff",
              width: "100%",
            }}
          >
            <Typography
              component="h3"
              sx={{
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>

            <IconButton
              color="inherit"
              aria-label="close modal"
              onClick={(e) => handleClose()}
              sx={{
                padding: "8px 14px",
                position: "relative",
                transform: "translateX(6px)",
              }}
            >
              <FontAwesomeIcon icon={faTimes} size={"lg"} />
            </IconButton>
          </Box>
          <Box
            sx={{
              padding: (theme) => theme.spacing(0),
              paddingTop: (theme) => theme.spacing(10),
              paddingBottom: (theme) => theme.spacing(0),
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            {children}
          </Box>
        </Paper>
      </Modal>
    </>
  );
};
export default CustomModal;
